module.exports = __webpack_public_path__ + "img/words2.d5c99d66.png";